export const actions = {
    SET_VALUE: 'SET_VALUE',
    SET_CART_FLAG_VALUE: 'SET_CART_FLAG_VALUE',
    SET_IS_VEHICLE_PROVIDED: 'SET_IS_VEHICLE_PROVIDED',
    SET_VEHICLE_NOT_PROVIDED: 'SET_VEHICLE_NOT_PROVIDED',
    SET_DISPATCHER: 'SET_DISPATCHER',
};
